class DailyRoutineView {

    constructor() {
        this.morningSlider = $('#morningtime');
        this.eveningSlider = $('#eveningtime');
    }
}
